"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentPrimitiveTypes = exports.Unknown = exports.Settings = exports.Gateway = exports.TemperatureSensor = exports.BooleanSensor = exports.Lighting = exports.HVAC = exports.EquipmentPrimitiveType = void 0;
var EquipmentPrimitiveType = /** @class */ (function () {
    function EquipmentPrimitiveType(name) {
        this.name = name;
    }
    return EquipmentPrimitiveType;
}());
exports.EquipmentPrimitiveType = EquipmentPrimitiveType;
exports.HVAC = new EquipmentPrimitiveType("HVAC");
exports.Lighting = new EquipmentPrimitiveType("Lighting");
exports.BooleanSensor = new EquipmentPrimitiveType("Boolean Sensors");
exports.TemperatureSensor = new EquipmentPrimitiveType("Temperature Sensors");
exports.Gateway = new EquipmentPrimitiveType("Gateway");
exports.Settings = new EquipmentPrimitiveType("Settings");
exports.Unknown = new EquipmentPrimitiveType("Other Devices");
exports.EquipmentPrimitiveTypes = [
    exports.HVAC,
    exports.Lighting,
    exports.TemperatureSensor,
    exports.BooleanSensor,
    exports.Gateway,
    exports.Settings,
    exports.Unknown
];
